import * as React from 'react';
import { IconButton } from 'ui';
import {
  DialogTitle as MuiDialogTitle,
  DialogTitleProps as MuiDialogTitleProps,
} from '@mui/material';
import { actionsContainer, closeButton, root, title } from 'ui/DialogTitle/dialogTitleCssDefs';
import CloseIcon from '@mui/icons-material/Close';

interface DialogTitleWrapperProps {
  id: string;
  onClose?(event: React.MouseEvent<HTMLButtonElement>): void;
  /**
   * Optional actions to display between the title and close button.
   * Useful for adding buttons or other interactive elements in the header.
   */
  actions?: React.ReactNode;
}

export type DialogTitleProps = MuiDialogTitleProps & DialogTitleWrapperProps;

/**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const DialogTitle = ({ children, onClose, id, actions, ...rest }: DialogTitleProps) => {
  return (
    <MuiDialogTitle id={id} css={root} {...rest}>
      <span css={title}>{children}</span>
      {(actions || onClose) && (
        <div css={actionsContainer}>
          {actions}
          {onClose ? (
            <IconButton
              aria-label="close"
              size="small"
              color="secondary"
              css={closeButton}
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </div>
      )}
    </MuiDialogTitle>
  );
};

export default DialogTitle;
